module.exports = __webpack_public_path__ + "img/mesas.584d8ebc.jpg";